<template>
  <div id="app">
    <Navigation v-if="isAuthenticated" />
    <main class="main-content" :class="{ 'with-nav': isAuthenticated }">
      <router-view v-if="!isAuthenticated"></router-view>
      <keep-alive v-else>
        <router-view></router-view>
      </keep-alive>
    </main>
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue';

export default {
  name: 'App',
  components: {
    Navigation
  },
  data() {
    return {
      isAuthenticated: false
    };
  },
  created() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      const token = localStorage.getItem('authToken');
      this.isAuthenticated = !!token;
    }
  },
  watch: {
    // 监听路由变化，检查认证状态
    '$route'() {
      this.checkAuth();
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}

.main-content {
  min-height: 100vh;
}

/* 当有导航栏时，为内容添加顶部间距 */
.main-content.with-nav {
  padding-top: 10px;
}

/* 登录页面布局 */
.main-content:not(.with-nav) {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

/* 保留原有的nav样式，但不再使用 */
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

/* 为路由视图容器设置样式 */
.main-content > * {
  width: 100%;
}
</style>
